module.exports = __webpack_public_path__ + "img/03.d8f7c34e.jpg";